module.exports = __webpack_public_path__ + "img/kaia.36085939.png";